import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import store from './store/store.js'
import './plugins/base'
import './plugins/chartist'
import mixins from '@/plugins/mixins';
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueMoment from 'vue-moment';
import { abilitiesPlugin } from '@casl/vue';
import ability from './config/ability';
import Cleave from 'cleave.js';

// Vee validate
import fr from 'vee-validate/dist/locale/fr.json';
import en from 'vee-validate/dist/locale/en.json';
import {required, email, max, min} from 'vee-validate/dist/rules';
import {extend, setInteractionMode, localize} from 'vee-validate';

localize({en, fr});
localize('fr');
setInteractionMode('eager');

extend('required', {
  ...required,
  message: (_, values) => i18n.t('validations.required')
});
extend('min', {
  ...min
});
extend('max', {
  ...max
});

extend('email', {
  ...email
});

extend('url', {
  validate: (str) => {
    var pattern = new RegExp('^(https?:\\/\\/)'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  },
  message: 'Ce n\'est pas une URL valide'
});
// #Vee validate

Vue.filter('round', function (value, decimals = 2) {
  if (!value) {
    value = 0;
  }

  if (!decimals) {
    decimals = 0;
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return value;
});

Vue.filter('gender', function (value) {
  let genderText = '-';
  if (value == 1) {
    genderText = 'Homme';
  } else if (value == 0) {
    genderText = 'Femme';
  }

  return genderText;
});

Vue.directive('cleave', {
  inserted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {})
  },
  update: (el) => {
    const event = new Event('input', {bubbles: true});
    setTimeout(function () {
      el.value = el.cleave.properties.result
      el.dispatchEvent(event)
    }, 100);
  }
});

Vue.config.productionTip = false;

Vue.use(VueMoment);
Vue.use(abilitiesPlugin, ability);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
